// Vento procedural — o feedback de velocidade mais importante do surf (docs/07).
// Ruído branco → 2 bandpass modulados por velocidade → gain por velocidade.
export class WindAudio {
  private ctx: AudioContext | null = null;
  private gain: GainNode | null = null;
  private bp1: BiquadFilterNode | null = null;
  private bp2: BiquadFilterNode | null = null;
  private started = false;
  volume = 0.7; // bus vento (settings na F6)

  /** Chamar após primeiro gesto do usuário (clique de pointer lock). */
  start(ctx: AudioContext, destination: AudioNode): void {
    if (this.started) return;
    this.started = true;
    this.ctx = ctx;

    // buffer de ruído branco de 2s em loop
    const len = ctx.sampleRate * 2;
    const buf = ctx.createBuffer(1, len, ctx.sampleRate);
    const data = buf.getChannelData(0);
    for (let i = 0; i < len; i++) data[i] = Math.random() * 2 - 1;
    const src = ctx.createBufferSource();
    src.buffer = buf;
    src.loop = true;

    this.bp1 = ctx.createBiquadFilter();
    this.bp1.type = 'bandpass';
    this.bp1.frequency.value = 300;
    this.bp1.Q.value = 0.6;

    this.bp2 = ctx.createBiquadFilter();
    this.bp2.type = 'bandpass';
    this.bp2.frequency.value = 800;
    this.bp2.Q.value = 1.2;

    this.gain = ctx.createGain();
    this.gain.gain.value = 0;

    src.connect(this.bp1);
    this.bp1.connect(this.gain);
    src.connect(this.bp2);
    this.bp2.connect(this.gain);
    this.gain.connect(destination);
    src.start();
  }

  /** speed em units/s; chamar por frame. */
  update(speed: number): void {
    if (!this.ctx || !this.gain || !this.bp1 || !this.bp2) return;
    const t = this.ctx.currentTime;
    // silencioso < 300 u/s, crescendo até uivar a 2000+
    const x = Math.max(0, Math.min(1, (speed - 300) / 1700));
    const vol = x * x * 0.55 * this.volume;
    this.gain.gain.setTargetAtTime(vol, t, 0.08);
    this.bp1.frequency.setTargetAtTime(300 + x * 500, t, 0.1);
    this.bp2.frequency.setTargetAtTime(800 + x * 1800, t, 0.1);
  }
}
